<template>
  <div class="card mb-25 border-0 radius-7 bg-white stats-item card-realtime-custom-mobile">
    <div class="card-body p-15 p-sm-20 p-md-25 pt-lg-30 letter-spacing heigth-card-realtime align-items-center d-flex">
      <div class="row justify-content-between">
        <div class="col-lg-5 col-md-5 flex-card-custom">
          <div
            class="icon position-relative text-primary rounded-1 text-center icon-realtime-custom-mobile"
          >
            <i class="flaticon-time"></i>
          </div>

          <div class="flex-lg-column ml-10 info d-flex align-items-center text-cards-realtime custom-realtime-title-mobile">
            <span class="fs-13 d-block text-uppercase text-dark-emphasis fw-bold">
              DURAÇÃO TOTAL DAS GRAVAÇÕES
            </span>
            <div class="d-flex align-items-center width-100 mt-2 custom-realtime-title-mobile">
              <h4 class="fw-black mb-0 me-10 lh-1">{{ convertTime(getCardsRealtime.total_time) }}</h4>
            </div>
          </div>

        </div>

      </div>
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent } from "vue";
import { mapGetters } from 'vuex';
import moment from 'moment';

export default defineComponent({
  name: "AnsweredTickets",

  data: function () {
    return {
      answered: [
        {
          name: "Answered Tickets",
          data: [8, 9, 10, 9, 9, 8, 9, 8, 9, 8, 7],
        },
      ],
      answeredTicketsChart: {
        chart: {
          type: "area",
          toolbar: {
            show: false,
          },
        },
        colors: ["#C57B0A"],
        dataLabels: {
          enabled: false,
        },
        xaxis: {
          labels: {
            show: false,
          },
          axisBorder: {
            show: false,
          },
          axisTicks: {
            show: false,
          },
          tooltip: {
            enabled: false,
          },
        },
        yaxis: {
          show: false,
        },
        grid: {
          show: false,
          strokeDashArray: 5,
          borderColor: "#dfe7f1",
        },
        tooltip: {
          enabled: false,
          style: {
            fontSize: "14px",
            fontFamily: "Red Hat Display, sans-serif",
          },
        },
      },
    };
  },
  methods: {
    convertTime(time: number | string) {
      const totalSeconds = Math.max(0, Math.floor(Number(time) || 0)); // lida com "96000.01243"
      const d = moment.duration(totalSeconds, 'seconds');

      const hours = Math.floor(d.asHours()); // horas **totais**, não %24
      const minutes = d.minutes();
      const seconds = d.seconds();

      const pad = (n: number) => String(n).padStart(2, '0');
      return `${pad(hours)}:${pad(minutes)}:${pad(seconds)}`; // ex.: 26:40:00
    }
  },
  computed:{
    ...mapGetters([
      'getCardsRealtime'
    ])
  },
});
</script>
